import {
  post
} from '../requisitions/Requisitions';

export var estabelishment = {
  singIn(data) {
    return post('estabelishment/login', data);
  }
}
